import React from 'react';
import { Button as ChakraButton } from '@chakra-ui/react';
import Image from '../../../components/content/image';
const HomeIcon = ({ companyPictureUrl, onClick }) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
        else {
            window.location.href = '/';
        }
    };
    return (<ChakraButton p={'0.15rem'} bgColor={'transparent'} borderRadius={'.5rem'} onClick={handleClick}>
      <Image imageURI={companyPictureUrl} width={'100%'} height={'100%'} borderRadius={'0.35rem'}/>
    </ChakraButton>);
};
export default HomeIcon;
